module.exports = __webpack_public_path__ + "img/timeline.ad62805c.png";